import React from "react"
import SEO from "../components/seo"
import Img from "gatsby-image"
import { graphql } from 'gatsby'
import S from "../PageStyles/aboutus.module.scss"

export default ({ data }) => {
  const {
    // id,
    block1Title,
    block2Title,
    block3Title,
    block1Content,
    block2Content,
    block3Content,
    block1Image,
    block2Image,
    block3Image,
  } = data.allContentfulAboutUs.edges[0].node

  return (
    <>
      <SEO title="Stalia | About Us and Where We Came From" />
      <section className={S.page}>
        <section id="block1" className={S.block1}>
          <Img
            className={S.image}
            fluid={block1Image.fluid}
            alt={block1Image.description}
          />
          <h2 className={S.title}>{block1Title}</h2>
          <div className={S.linebreaker} />
          <div
            className={S.contentblock}
            dangerouslySetInnerHTML={{
              __html: block1Content.childMarkdownRemark.html,
            }}
          />
        </section>
        <section id="block2" className={S.block2}>
          <Img
            className={S.image}
            fluid={block2Image.fluid}
            alt={block2Image.description}
          />
          <h2 className={S.title}>{block2Title}</h2>
          <div className={S.linebreaker} />
          <div
            className={S.contentblock}
            dangerouslySetInnerHTML={{
              __html: block2Content.childMarkdownRemark.html,
            }}
          />
        </section>
        <section id="block3" className={S.block3}>
          <Img
            className={S.image}
            fluid={block3Image.fluid}
            alt={block3Image.description}
          />
          <h2 className={S.title}>{block3Title}</h2>
          <div className={S.linebreaker} />
          <div
            className={S.contentblock}
            dangerouslySetInnerHTML={{
              __html: block3Content.childMarkdownRemark.html,
            }}
          />
        </section>
      </section>
    </>
  )
}

export const query = graphql`
  {
    allContentfulAboutUs {
      edges {
        node {
          id
          block1Title
          block1Content {
            childMarkdownRemark {
              html
            }
          }
          block1Image {
            fluid {
              ...GatsbyContentfulFluid
            }
            description
          }
          block2Title
          block2Content {
            childMarkdownRemark {
              html
            }
          }
          block2Image {
            fluid {
              ...GatsbyContentfulFluid
            }
            description
          }

          block3Title
          block3Content {
            childMarkdownRemark {
              html
            }
          }
          block3Image {
            fluid {
              ...GatsbyContentfulFluid
            }
            description
          }
        }
      }
    }
  }
`
